<div class="snack-bar-item" [ngClass]="[data.type || 'default']">
  <div class="snack-bar-item-body">
    @if (data.title) {
      <div class="snack-bar-title" [innerHTML]="data.title"></div>
    }
    @if (data.message) {
      <div class="snack-bar-message" [innerHTML]="data.message"></div>
    }
  </div>
  <div class="snack-bar-item-action">
    <button class="no-style-button snack-bar-dismiss" [attr.aria-label]="'Zamknij'" (click)="dismiss()"><i class="fa-sharp fa-regular fa-xmark"></i></button>
  </div>
</div>
